import { styled } from '@terra/ui-styled-system';
import { type TextVariantProps, text } from '@terra/ui-styled-system';
import type { ComponentProps, StyledComponent } from '@terra/ui-styled-system';

type ParagraphProps = TextVariantProps & { as?: React.ElementType };

export type TextProps = ComponentProps<typeof Text>;
export const Text = styled('p', text) as StyledComponent<'p', ParagraphProps>;
